import { FormEvent, ReactNode } from "react";
import "./Button.scss";
export interface ButtonProps {
  label: string | ReactNode;
  type?: "submit" | "button";
  disabled?: boolean;
  onClick?: (evt: FormEvent) => void;
  active?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  type = "button",
  disabled = false,
  active = false,
}) => {
  return (
    <div className="button__wrapper">
      <button
        className={`button__wrapper__button ${active ? "active" : ""}`}
        type={type}
        onClick={onClick}
        disabled={disabled}
      >
        {typeof label === "string" ? (
          <p className="button__wrapper__button__label">{label}</p>
        ) : (
          label
        )}
      </button>
    </div>
  );
};
